module.exports = __webpack_public_path__ + "static/mucap-2e97a6ee8558cd5ed4fbb63ff9301260.png";